import { Helmet } from "react-helmet";

const BreadcrumbSchema = ({
pageName,
pageUrl
})=>{

const schema={
"@context":"https://schema.org",
"@type":"BreadcrumbList",

"itemListElement":[

{
"@type":"ListItem",
"position":1,
"name":"Home",
"item":"https://bushireinpune.com"
},

{
"@type":"ListItem",
"position":2,
"name":"Bus On Rent In Pune",
"item":"https://bushireinpune.com/bus-on-rent-in-pune"
},

{
"@type":"ListItem",
"position":3,
"name":pageName,
"item":pageUrl
}

]

};

return(

<Helmet>

<script type="application/ld+json">

{JSON.stringify(schema)}

</script>

</Helmet>

);

};

export default BreadcrumbSchema;